// extracted by mini-css-extract-plugin
export default {"selectbox":"style_selectbox__H+GW+","selectUl":"style_selectUl__RExOS"};